import { Breadcrumb } from 'features/page-model';

function filterBreadcrumbs(breadcrumbs: Breadcrumb[], isMobileDevice: boolean): Breadcrumb[] {
  if (breadcrumbs.length > 1) {
    const startIndex = isMobileDevice && breadcrumbs.length > 1 ? 1 : 0;
    return breadcrumbs.slice(startIndex, breadcrumbs.length - 1);
  }

  return breadcrumbs;
}

export { filterBreadcrumbs };
